/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedautosendcertifatesenabled4Inputs */

const en__field_inheritedautosendcertifatesenabled4 = /** @type {(inputs: _Field_Inheritedautosendcertifatesenabled4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`send certificates automatically (derived)`)
};

const de__field_inheritedautosendcertifatesenabled4 = /** @type {(inputs: _Field_Inheritedautosendcertifatesenabled4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auto Zertifikat Versandt aktiviert (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "send certificates automatically (derived)" |
*
* @param {_Field_Inheritedautosendcertifatesenabled4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedautosendcertifatesenabled4 = /** @type {((inputs?: _Field_Inheritedautosendcertifatesenabled4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedautosendcertifatesenabled4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedautosendcertifatesenabled4(inputs)
	return de__field_inheritedautosendcertifatesenabled4(inputs)
});
export { _field_inheritedautosendcertifatesenabled4 as "_field_inheritedAutoSendCertifatesEnabled" }